import { combineReducers } from "redux";
import app from "../reducers";

const reducer = combineReducers({
  app,
});

export default reducer;
